import React from "react";
import { XStackContainer } from "../../Containers";
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";

import { CheckboxListFormControl } from "../Web/CheckboxListFormControl";
import { ExecutionData } from "../../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

function getUI(): { form: FormConfiguration; control: CheckboxListFormControl } {
    let ui = new FormConfiguration();
    let container = new XStackContainer();

    ui.add(container);

    let checkboxlist = new CheckboxListFormControl();
    checkboxlist.valueName = "checkboxList";
    checkboxlist.list = [
        "Operator",
        "Manager",
        "Administration",
        "UX/UI designer",
        "Back-end developer",
        "Project-manager",
    ];
    container.add(checkboxlist);

    return { form: ui, control: checkboxlist };
}

export const CheckboxListStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.label = "Default Control";
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Checkbox List",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.label = "With Values";

            let data = new ExecutionData();
            data.values["checkboxList"] = {
                Operator: true,
            };
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Checkbox List",
        "With Values",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.label = "Required One Selection At Least";
            let data = new ExecutionData();
            data.values["checkboxList"] = {
                Operator: false,
            };
            ui.control.requiredOneSelectionAtLeast = true;
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Checkbox List",
        "Require One Selection",
    ),
];
